const When = ({
  isTrue,
  children,
}: {
  isTrue: boolean;
  children: JSX.Element;
}) => {
  if (!isTrue) {
    return null;
  }

  return <>{children}</>;
};

export default When;
